export const CRM_EMAIL_FREQUENCIES = [
  { value: 'instant', label: 'instant' },
  { value: '15m', label: '15-minutes' },
  { value: '30m', label: '30-minutes' },
  { value: '60m', label: '1-hour' },
];

export const CRM_EMAIL_FREQUENCY_VALUES = CRM_EMAIL_FREQUENCIES.map(({ value }) => value);

export const hasCrmEmailPreference = (user) => CRM_EMAIL_FREQUENCY_VALUES.includes(user?.crmEmailFrequency);

const CRM_RECAP_FLAG_VALUES = new Set([0, 1, true, false]);

export const hasCrmRecapPreference = (user) => CRM_RECAP_FLAG_VALUES.has(user?.crmDailyRecap);
